import { ISidebarHelp } from 'models/sidebarHelp/sidebarHelp.model';
import { URL_CT360, URL_FALE_CONOSCO } from 'utils/consts/global';

export const helpCollaboration: ISidebarHelp = {
	title: 'Colaborações',
	firstParagraph: `Etapa destinada a colaboração dos especialistas de negócios da empresa, representados pelas áreas: comercial, marketing e planejamento.`,
	secondParagraph: `Cada especialista deve realizar sua colaboração de maneira independente no horizonte de tempo definido, sem sofrer qualquer tipo de influência, considerando todas as informações [quanti e quali] que possam auxiliá-los nesse exercício.`,
	thirdParagraph: `Acesse o botão para realizar sua colaboração.`,
	firstLink: URL_CT360,
	secondLink: URL_FALE_CONOSCO,
};
